// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"1e3f748b","227":"b2ce20d1","333":"32179211","447":"d0098dfc","461":"a6737d15","600":"b4653118","676":"ee034c60","954":"309f4fe8"}[chunkId] + ".chunk.js";
};